import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Table from "./Table"
import { getAllSports } from "store/Sports/actions"
import { useSelector, useDispatch } from "react-redux"
import axios from "axios"
import { getSports, getMarkets } from "helpers/repository"
import { getAllMarkets } from "store/markets/actions"
import {sitename} from "../../../../constants/constants";

const Sports = props => {
  const dispatch = useDispatch()
  const [sportsData, setSportsData] = useState([])
  const [marketsData, setMarketsData] = useState([])
  const [totalSportsData, setTotalSportsData] = useState(0)
  useEffect(() => {
    getSports(getSportsSuccess, getSportsError)
    getMarkets(getMarketsSuccess, getMarketsError)
    // dispatch(getAllMarkets())
    // dispatch(getAllSports())
  }, [])

  const getSportsSuccess = res => {
    setSportsData(res?.data?.data ?? [])
    setTotalSportsData(res.data.total)
  }
  const getMarketsSuccess = res => {
    setMarketsData(res?.data?.data ?? [])
  }

  const getSportsError = error => {}

  const getMarketsError = error => {}

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Sports" />
        </Container>
        <Table
          data={sportsData}
          marketData={marketsData}
          getSports={() => {
            getSports(getSportsSuccess, getSportsError)
          }}
          getMarkets={() => {
            getMarkets(getMarketsSuccess, getMarketsError)
          }}
          count={totalSportsData}
        />
      </div>
    </React.Fragment>
  )
}

export default withRouter(Sports)
